export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 50;
export const SEARCH_DEBOUNCE_MS = 400;
export const NO_STATUSES = [];
